import { qwertyLayout } from "utils/keyboard-layout";
import React from "react";
import StyledButton from "components/styled-button";
import "components/styled-button/styled-button.css";

type Props = {
  onCharClick: (char: string) => void;
  style?: React.CSSProperties;
  className?: string;
  disabled?: boolean;
};

const Keyboard: React.FC<Props> = ({
  onCharClick,
  style,
  className,
  disabled,
}) => {
  return (
    <div className={`keyboard ${className}`} style={style}>
      {qwertyLayout.map(({ char, svg, gap, span }, index) => (
        <StyledButton
          key={index}
          onClick={() => onCharClick(char)}
          className={char.toUpperCase()}
          style={{
            gridColumn: `span ${span ?? 1}${gap ? " / " + gap : ""}`,
          }}
          disabled={disabled}
        >
          <span>{svg ?? char}</span>
        </StyledButton>
      ))}
    </div>
  );
};

export default Keyboard;
